/** Shared layout classes for seller auth screens — mobile-first, desktop unchanged at lg+. */

export const AUTH_FORM_SHELL_CLASS =
  "mx-auto box-border flex min-h-[calc(100dvh-80px)] w-full max-w-[640px] flex-col justify-center px-4 py-6 sm:px-6 sm:py-8 lg:min-h-full lg:h-full lg:w-[70%] lg:max-w-none lg:px-0 lg:py-8";

export const AUTH_ONBOARDING_SHELL_CLASS =
  "mx-auto flex box-border  w-full max-w-[520px] flex-col justify-center px-4 py-8 sm:px-6 lg:min-h-full lg:w-[50%] lg:max-w-none lg:px-0 lg:py-0";
